import { render } from "./IconPlay.vue?vue&type=template&id=245ef692"
import script from "./IconPlay.vue?vue&type=script&lang=js"
export * from "./IconPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__